import { SignIn } from '@clerk/clerk-react';
import { Logo } from '../components/Logo';

export function Login() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 relative overflow-hidden">
      <div className="w-full max-w-md relative z-10">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <Logo size="lg" showText={false} />
          </div>
          <h1 className="text-3xl font-semibold mb-2 text-foreground">
            Lynqio
          </h1>
          <p className="text-muted-foreground">
            LinkedIn automation for recruiters
          </p>
        </div>

        <div className="glass-card p-8 !border-0 shadow-2xl">
          <SignIn 
            path="/login"
            signUpUrl="/sign-up"
            fallbackRedirectUrl="/"
            forceRedirectUrl="/"
          />
        </div>
      </div>
    </div>
  );
}